(function (app, ng) {

    app.controller("addToActOnController", addToActOnController);

    addToActOnController.$inject = ["$mdDialog", "marketingTrackerActOnApi", "figToaster", "amplitudeService"];
    function addToActOnController($mdDialog, marketingTrackerActOnApi, figToaster, amplitudeService) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    exporting: false
                },
                exportToActOn: exportToActOn,
                close: close
            });

        function exportToActOn(filteredList) {
            $ctrl.ui.exporting = true;
            marketingTrackerActOnApi.postRespondersToActonList($ctrl.selectedActOnList.id, filteredList)
                .then(function (response) {
                    $ctrl.ui.exporting = false;
                    console.log(response);
                    message = $ctrl.filteredList.length + " responders sent to Act-On.";
                    toastClass = "is-success";
                    amplitudeService.logClickEvent('Export Responder List to Act-On');
                })
                .catch(function (error) {
                    message = "Error: " + error.data;
                    toastClass = "is-error";
                })
                .finally(function () {
                    $mdDialog.hide({
                        selectedResponderStatus: $ctrl.selectedResponderStatus,
                        selectedAttendanceStatus: $ctrl.selectedAttendanceStatus
                    });
                    return figToaster.showSimple(message, "top", toastClass);
                });
        }

        function close() {
            $mdDialog.hide();
        }

        $ctrl.$onInit = function () {

        };
    }
})(window.app, window.angular); //jshint ignore:line
